import { Project } from './Project';

export const PROJECTS = [
    new Project({
        id: 12,
        name: 'PathSketch',
        description: 'Draw your next running route! Make any doodle and PathSketch automatically finds real road routes near you that match it. The drawing is vectorized into a series of straight segments, the vertices are overlaid on the map, snapped to the nearest roads, and connected by shortest road paths to form a candidate route. Candidates are generated across many nearby locations and scored by total distance, since the shortest path between two points is a straight line, the shortest candidate best matches the drawing. Map data is preloaded while the user draws and cached per location to keep generation fast. React front end and Python back end hosted in Azure.',
        reason: 'Web/API',
        technologies: ['Python', 'React', 'Mapbox API', 'Azure', 'Algorithms'],
        images: ['assets/ps_demo.gif', 'assets/ps_draw.png', 'assets/ps_results.png'],
        ranking: 2,
    }),
    new Project({
        id: 1,
        name: 'Logan Holmes Runs',
        description: 'Website and mobile app to visualize my running data. Built in Wordpress using a theme created from scratch. Interfaces with the Strava API. Uses multiple visualization techniques with Leafet and OpenMapBox. Also interfaces with GMail API in order to allow for livetracking from my watch when racing.',
        reason: 'Web/API',
        technologies: ['API', 'Wordpress', 'PHP', 'SQL', 'JS'],
        iosUrl: 'https://apps.apple.com/in/app/logan-holmes-runs/id6447003853',
        images: ['lhr_map.png', 'lhr_app.png'],
        ranking: 5,
    }),
    new Project({
        id: 14,
        name: '3D Store Viewer',
        description: 'Joins the views of multiple cameras in a space into a single shared 3D point cloud, running in real time on basic store security camera footage. Uses monocular depth estimation and segmentation models to lift each camera feed into 3D and fuse them into one scene. This is the foundational piece of a larger computer vision system I have been building to provide insights to business owners.',
        reason: 'AI/ML',
        technologies: ['Python', 'AI/ML', 'Computer Vision', 'Depth Estimation', 'Segmentation'],
        images: ['assets/sv_demo.gif', 'assets/sv_cloud.png', 'assets/sv_cameras.png'],
        ranking: 1,
    }),
    new Project({
        id: 4,
        name: 'March Madness Bracket Maker',
        description: 'A deep nueral network trained on all March Madness games using team statistics. Generates a unique bracket from the model each time. Hosted on Azure using a Function endpoint. The frontend is made in react.',
        reason: 'AI/ML',
        technologies: ['ML', 'Deep Nueral Network', 'Python', 'React', 'Azure'],
        images: ['bracket_home.png', 'bracket_drawn.png'],
        ranking: 4,
    }),
    new Project({
        id: 5,
        name: 'Play Viewer',
        description: 'A computer vision model that detects football players throughout a play and translates them onto a top down view for analysis. Detection of players and keypoints as well as transformation onto a 2d plane. Using Roboflow datasets, OpenCV, Supervision, and YOLO.',
        reason: 'AI/ML',
        technologies: ['Computer Vision', 'Python', 'OpenCV', 'YOLO'],
        images: ['play_view_gif.gif', 'play_view.png'],
        ranking: 3,
    }),
    new Project({
        id: 7,
        name: 'Playbook Tool',
        description: 'Python app using QT Creator allowing users to create football plays. The plays are stored and there is an option to study and test on the plays created. Playbooks can be saved and loaded to the file system.',
        reason: 'school',
        technologies: ['Python', 'QT Creator'],
        images: ['pb_home.png', 'pb_create.png', 'pb_study.png', 'pb_test.png'],
        ranking: 3,
    }),
    new Project({
        id: 8,
        name: 'Tank Wars',
        description: 'An online multiplayer tank shooting game with a custom programmed server and client system. Uses websockets to establish connections and send data between client and server.',
        reason: 'school',
        technologies: ['Windows Forms App', 'Web Sockets'],
        images: ['tanks_playing.png'],
        ranking: 2,
    }),
    new Project({
        id: 9,
        name: 'Statistics Dashboard',
        description: 'Built a new dashboard for live statistics and historical data to replace existing legacy dashboards. Using many types of graphs and data visualizations to display information. Makes use of advanced SQL queries to get relevant data. Built in Java Springboot.',
        reason: 'work',
        technologies: ['Java', 'Springboot', 'SQL', 'JS'],
        images: ['no_image.jpg'],
        ranking: 1,
    }),
    new Project({
        id: 10,
        name: 'In Store Displays',
        description: 'Developed a website which will act as an information display in stores. Communicates with database to update data in live time. Built for IceWeasel browser in order to work on store servers. Built in Java Springboot.',
        reason: 'work',
        technologies: ['Java', 'Springboot', 'SQL'],
        images: ['no_image.jpg'],
        ranking: 3,
    }),
    new Project({
        id: 11,
        name: 'Data Visualization Website',
        description: 'Designed and implemented a website to visualize experiment results in an organized manner. Organizes the many images from experiments and allows for filtering, self comparison, and external comparison. Built in ASP.NET Core and offers an API endpoint to get existing experiment data and upload new data. Website and database are hosted on Azure.',
        reason: 'work',
        technologies: ['C#', 'SQL', 'Azure'],
        images: ['no_image.jpg'],
        ranking: 2,
    }),
];